/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const DEFAULT_ONTOLOGY_API_BASE_URL = 'https://abrbt.leandc.cn/api';
const DEFAULT_ONTOLOGY_PORTAL_URL = 'https://abrbt.leandc.cn/ontology';

function stripTrailingSlash(url: string): string {
  return url.replace(/\/$/, '');
}

/**
 * 本体 KAG API 根地址（含 `/api`）。
 * 配置于 `VITE_ONTOLOGY_API_BASE_URL`；本地 dev 可用 `/ontology-api` 走 rsbuild 代理。
 */
export function getOntologyApiBaseUrl(): string {
  if (typeof import.meta !== 'undefined') {
    const raw = import.meta.env.VITE_ONTOLOGY_API_BASE_URL;
    if (raw && String(raw).trim()) {
      return stripTrailingSlash(String(raw).trim());
    }
  }
  return DEFAULT_ONTOLOGY_API_BASE_URL;
}

/** 本体管理端门户地址，配置于 `VITE_ONTOLOGY_PORTAL_URL`。 */
export function getOntologyPortalUrl(): string {
  if (typeof import.meta !== 'undefined') {
    const raw = import.meta.env.VITE_ONTOLOGY_PORTAL_URL;
    if (raw && String(raw).trim()) {
      return stripTrailingSlash(String(raw).trim());
    }
  }
  return DEFAULT_ONTOLOGY_PORTAL_URL;
}

/** 解析本体 API 地址；支持 `/ontology-api/...` 等相对路径（dev 代理）。 */
export function resolveOntologyRequestUrl(pathOrUrl: string): URL {
  if (pathOrUrl.startsWith('/')) {
    const origin =
      typeof window !== 'undefined'
        ? window.location.origin
        : 'http://localhost';
    return new URL(pathOrUrl, origin);
  }
  return new URL(pathOrUrl);
}
